export default __webpack_public_path__ + "static/blob9-1328740fbc7d4e5db93028ba15614ab4.svg";